import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@app/store';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface LeadCardRefreshState {
  // Lead id whose card data must be refetched after an external change the card
  // cannot observe in place (e.g. saving the client note from the edit client
  // page). It is consumed and reset by the lead data layer once the matching
  // lead card refetches, so returning to the card shows fresh data without a
  // manual page refresh.
  pendingLeadId: number | null;
}

const initialState: LeadCardRefreshState = {
  pendingLeadId: null,
};

const leadCardRefreshSlice = createSlice({
  name: 'leadCardRefresh',
  initialState,
  reducers: {
    requestLeadCardRefresh: (state, action: PayloadAction<number>) => {
      state.pendingLeadId = action.payload;
    },
    clearLeadCardRefresh: (state) => {
      state.pendingLeadId = null;
    },
  },
});

const { actions, reducer } = leadCardRefreshSlice;

export const { requestLeadCardRefresh, clearLeadCardRefresh } = actions;

export const selectPendingLeadCardRefreshId = (
  state: RootState
): number | null => state.leadCardRefresh.pendingLeadId;

export const leadCardRefreshReducer = reducer;
